import React from 'react';
import { Link } from 'react-router-dom';



const TopbarS2 = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0)
    }
    return (
        <div className="topbar topbar-s2">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-md-8 col-12">
                        <ul className="contact-info">
                            <li>
                                <a href="tel:+887869587496">
                                    Call Us:
                                    <span>+ +91 7331149267</span>
                                </a>
                            </li>
                            <li>
                                <span>
                                    Email Us:
                                </span>
                                <span>yvreddyassociates.com@gmail.com</span>
                            </li>

                        </ul>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12">
                        <div className="contact-into">
                           <ul className="social-media">
    <li>
        <a
            href="https://www.facebook.com/yvreddyassociate"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="ti-facebook"></i>
        </a>
    </li>

    <li>
        <a
            href="https://www.youtube.com/@yvreddyassociates774"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="ti-youtube"></i>
        </a>
    </li>

    <li>
        <a
            href="https://www.instagram.com/yv_reddy_associates"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="ti-instagram"></i>
        </a>
    </li>
</ul>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopbarS2;